var domRimFilters, isSmallScreen, cpSticky, carPreviewVars, listingItemsVars;

var resp = new function() {
	var _self = this;

	this.bindUi = function () {
		domRimFilters = $('div#listing > div#facetsidebar');
		$('#btn-show-fr').on('click', function () {
			domRimFilters.show();
		});
		$('#btn-hide-fr').on('click', function () {
			domRimFilters.hide();
		});
	};
	

	this.devRotated = function () {
		$('body').removeClass('landscape');
		$('body').addClass(90 === Math.abs(window.orientation) ? "landscape" : "");
		$("#btn-hide-cpr").trigger('click');
		if ($('body').hasClass("landscape") && ($(window).width() >= 991)) {
			domRimFilters.show();
		} else {
			domRimFilters.hide();
		}
	};

	this.calcMobPreview = function () {
		var cPrev = $("div#vehicle-preview");
		var mobileNavMenu = $('.mobile-nav-menu');
		var carOs = cPrev.offset();
		var sEdge = carOs.top + parseInt(cPrev.parent().css('paddingBottom')) + cPrev.height()
			- (mobileNavMenu.length > 0 ? mobileNavMenu.outerHeight() : 0);
		return sEdge;
	};
	
	this.visibleHeight = function (item) {
		var elBottom, elTop, scrollBot, scrollTop, visibleBottom, visibleTop;
		scrollTop = $(window).scrollTop();
		scrollBot = scrollTop + $(window).height();
		elTop = item.offset().top;
		elBottom = elTop + item.outerHeight();
		visibleTop = elTop < scrollTop ? scrollTop : elTop;
		visibleBottom = elBottom > scrollBot ? scrollBot : elBottom;
		return visibleBottom - visibleTop
	};

	this.mobCarPreview = function () {

		// CHANGE
		var carPreview = $("#mobile-car-preview");
		var carPreviewHeight = carPreview.outerHeight();

		var btnshowcpr = $('#btn-hide-cpr');

		var rightContainer = $('#right-container');
		var rightContainerTop = rightContainer.offset().top;
		var rightContainerHeight = rightContainer.outerHeight();

		var fixedbutoonbar = $('#fixed-butoon-bar');
		var fixedbutoonbarHeight = fixedbutoonbar.outerHeight();

		var rightContainerBottomForButton = rightContainerTop + rightContainerHeight - fixedbutoonbarHeight;
		var rightContainerBottomForcarPreview = rightContainerHeight + rightContainerTop - carPreviewHeight;

		var cPreview = $('#preview-container');
		var cpParent = $('#preview');
		cPreview.removeClass('sticky').removeAttr("style");
		cpParent.removeClass('container-fixed-block');
		cPreview.removeClass('fixed-block');

		if (!carPreview.hasClass('active')) {
			var carPrevBottom = _self.calcMobPreview();
			if($(window).scrollTop() <= carPrevBottom){
				if ($('#btn-show-cpr').is(":visible")) {
					$('#btn-show-cpr').hide();
				}
			}else{
				if (($(window).scrollTop() >= rightContainerBottomForButton)) {
					fixedbutoonbar.addClass('mobile-fixed-button');
				}else{
					fixedbutoonbar.removeClass('mobile-fixed-button');
				}

				$('#btn-show-cpr').show();

				$('#btn-show-cpr').on('click', function() {
					$("#btn-hide-cpr").show();
					carPreview.addClass('active');

					if (($(window).scrollTop() >= rightContainerBottomForcarPreview - carPreviewHeight)) {
						btnshowcpr.addClass('display-none');
						fixedbutoonbar.addClass('mobile-fixed-button');
						carPreview.addClass('mobile-fixed');
					}
				});
				$("#btn-hide-cpr").on('click', function() {
					carPreview.removeClass('active');
					$(this).hide();
					if($(window).scrollTop() <= carPrevBottom){
						if ($('#btn-show-cpr').is(":visible")) {
							$('#btn-show-cpr').hide();
						}
					}
					fixedbutoonbar.removeClass('mobile-fixed-button');
					carPreview.removeClass('mobile-fixed');
				});
			}
		} else {
			if (($(window).scrollTop() >= rightContainerBottomForcarPreview)) {
				fixedbutoonbar.addClass('mobile-fixed-button');
				carPreview.addClass('mobile-fixed');
			}else{
				carPreview.removeClass('mobile-fixed');
				fixedbutoonbar.removeClass('mobile-fixed-button');
				btnshowcpr.removeClass('display-none');
			}
			if ($('#mobile-car-preview.active').length===0) {
				$('#btn-show-cpr').hide();
				carPreview.removeClass('active');
				carPreview.removeClass('mobile-fixed');
				fixedbutoonbar.removeClass('mobile-fixed-button');
			}
		}
	};

	this.carPreviewInit = function () {
		var btnshowcpr = $('#btn-hide-cpr');

		$("#fixed-butoon-bar").css({
			top: $('.mobile-nav-menu').outerHeight()
		});

		if ($("#mobile-car-preview").length===0) {
			$("#preview").wrap('<div id="mobile-car-preview" class="row"></div>');
		}
		if (isSmallScreen) {
			_self.mobCarPreview();
			$('#complete_wheels_root form[name="facetsidebar"]').removeAttr('style');
		}
		_self.stickyCar();
	};

	this.cwTabsButtons = function () {
		if ($('#carselector .columns').length > 1) {
			$('#carselector').prepend('<ul id="cw-tabs"></ul>');
			var i = 0;
			$('#carselector .columns').each(function () {
				var cwtab = "cwtab-" + i;
				var cwtabtitle = $(this).find('#title').text();
				var cwactive = (i === 0) ? ('active') : ('');
				$('#cw-tabs').append('<li class="' + cwactive + '" data-href="' + cwtab + '">' + cwtabtitle + '</li>');
				$(this).addClass(cwtab)
					.parents().addClass(cwactive);
				i++;
			});
			$('#cw-tabs li').on('click', function () {
				var cwtab = $(this).attr('data-href');
				$('#carselector > div').hide();
				$('#carselector .' + cwtab).parents().show();
				$('#cw-tabs li').removeClass('active');
				$(this).addClass('active');
			})
		}
	};

	this.cwCarColors = function () {
		var colorsToggle = $('#car-colors-toggle');
		var btnHideCs = $('#btn-hide-cs');
        colorsToggle.on('click touchstart', function () {
			$('.car-colors-tooltip').toggleClass('active');
			return false;
		});
        $(document).on('click touchstart mouseover', function(e){
            var nameClassOfElemet = e.target.getAttribute('class');

            if((nameClassOfElemet != 'colors-set1') &&
                (nameClassOfElemet != 'car-colors-tooltip active') &&
                (nameClassOfElemet != 'target-color')){
                $('.car-colors-tooltip.active').removeClass('active');
            }
        });
		btnHideCs.on('click', function () {
			$(this).parent().toggleClass('active');
		})
	};
	
	this.initVars = function () {
		carPreviewVars = {
			cPreview: $('#preview-container'),
			cpParent: $('#preview')
		};
		carPreviewVars.cpPreviewContainerHeight = carPreviewVars.cPreview.outerHeight();
		carPreviewVars.cpTop = carPreviewVars.cpParent.offset().top;
		carPreviewVars.cpWidth = carPreviewVars.cpParent.width();
		carPreviewVars.cpHeight = carPreviewVars.cpParent.outerHeight();

		listingItemsVars = {
			listingItems: $('#listing-items')
		};

		listingItemsVars.listingItemsHeight = listingItemsVars.listingItems.height();
		listingItemsVars.listingItemsHeightWithMargins = listingItemsVars.listingItems.outerHeight(true);
		listingItemsVars.listingItemsContainerTop = listingItemsVars.listingItems.offset().top; // height from the beginning of the document to the beginning of the element
		listingItemsVars.listingItemsLastChild = listingItemsVars.listingItems.children().not('.hidden').last();
		listingItemsVars.listingItemsLastChildMarginBottom = parseInt(listingItemsVars.listingItemsLastChild.css('margin-bottom'));
		listingItemsVars.listingItemsLastChildHeight = 2 * (listingItemsVars.listingItemsLastChild.outerHeight() + listingItemsVars.listingItemsLastChildMarginBottom);
		
	};
	
	this.stickyRimsFilters = function (rightContainerBottom) {
		
		var rightContainer = $('#right-container');
		
		var filterContainer = $('#facetsidebar.filters');
		var filtersForm = $('#complete_wheels_root form[name="facetsidebar"]'); //local variable of form filters
		
		if (($(window).scrollTop() > carPreviewVars.cpTop) && !isSmallScreen && (listingItemsVars.listingItemsHeight > 100)) {
			
			if (!cpSticky) {
				filterContainer.removeAttr('style');
				//implementing of sticky filtersForm for search rim pages
				filtersForm.css({
					position: 'fixed',
					top: carPreviewVars.cpPreviewContainerHeight + 10,
					overflowY: 'scroll',
					overflowX: 'hidden',
					maxHeight: $(window).outerHeight() - (carPreviewVars.cpPreviewContainerHeight + 20)
				});
			}
			
			if (this.amountScrolled() >= this.calculateHeight()) {
				
				var comparingRimContainer = $('.comparing-rims-wrapper');
				var comparingRimContainerHeight = comparingRimContainer.outerHeight(); //height of comparison without margins
				var sortRims = $('.sorts-for-rims'); // sorts of rims
				var sortHeightAndComparing = comparingRimContainerHeight + sortRims.outerHeight(true); //height of sorts and comparison
				var comparingRimItem = $('#comparing-rims .item-rim');
				var isHasComparingRimsChildren = comparingRimItem.length;
				var itemRimHeight = $('.item-rim').height();
				var heightFilterContainer = listingItemsVars.listingItemsHeightWithMargins + sortRims.outerHeight(true); //calculate of height for filter container
				var heightFilterForm = _self.visibleHeight(listingItemsVars.listingItems); //calculate visible height for filters form
				var topPos = heightFilterContainer - heightFilterForm; //calculate of top position for filters form
				var bottomPos = 0;
				
				filterContainer.css({
					height: heightFilterContainer
				});
				
				if (isHasComparingRimsChildren) {
					//increase the height if has comparison rims
					
					//calculate of maxHeight with the block of comparison rims - height of sort div + margins
					var heightFilterContainerWithComparing = listingItemsVars.listingItemsHeightWithMargins + sortHeightAndComparing;
					
					topPos = heightFilterContainerWithComparing - heightFilterForm + 20; //calculate the new top position with height of the compare rims wrapper
					
				
					if (listingItemsVars.listingItemsHeight < itemRimHeight * 2) {
						//has only one row of rims and has comparison wrapper with rims
						
						var _comparingRimContainerHeight = _self.visibleHeight(comparingRimContainer) > 0 ? comparingRimContainerHeight - _self.visibleHeight(comparingRimContainer) : sortHeightAndComparing + 10;
						var hFilterComparing = listingItemsVars.listingItemsHeightWithMargins + _comparingRimContainerHeight; //height filters container with comparison div
						
						topPos = hFilterComparing - heightFilterForm; //calculate the new top position with height of the compare rims wrapper
						heightFilterForm = heightFilterForm + comparingRimContainerHeight;
					}
					
					filterContainer.css({
						height: heightFilterContainerWithComparing - 10
					});
					
				} else if (listingItemsVars.listingItemsHeight < itemRimHeight * 2 && !isHasComparingRimsChildren) {
					//if has only 1 row in list of rims without comparing
					
					topPos = 0;
					bottomPos = 'auto';
					heightFilterForm = itemRimHeight - 20;
				}
				
				filtersForm.css({
					position: 'absolute',
					top: topPos + 10,
					bottom: bottomPos,
					overflowY: 'scroll',
					overflowX: 'hidden',
					maxHeight: heightFilterForm
				});
				rightContainer.addClass('right-layout-container');
				
			} else {
			    var bottomListingItems = listingItemsVars.listingItemsContainerTop + listingItemsVars.listingItemsHeightWithMargins;
				var scrollDocument = $(document).scrollTop() + $(window).outerHeight();
				var heightDiff = scrollDocument - bottomListingItems;
				var heightFiltersIsVisibleFooter =  $(window).outerHeight() - carPreviewVars.cpPreviewContainerHeight - heightDiff;
				var heightFilters = $(window).outerHeight() - carPreviewVars.cpPreviewContainerHeight - 20;
			
				rightContainer.removeClass('right-layout-container');
				filterContainer.removeAttr('style');
				filtersForm.css({
					position: 'fixed',
					top: carPreviewVars.cpPreviewContainerHeight + 10,
					overflowY: 'scroll',
					overflowX: 'hidden',
					maxHeight: scrollDocument > bottomListingItems
						? heightFiltersIsVisibleFooter : heightFilters
				});
			}
		} else if (cpSticky) {
			
			filtersForm.removeAttr('style');
			filterContainer.removeAttr('style');
		}
	};
	
	this.stickyCar = function () {
		
		_self.initVars();
		
		var rightContainerBottom =
			listingItemsVars.listingItemsHeight + listingItemsVars.listingItemsContainerTop - carPreviewVars.cpHeight - listingItemsVars.listingItemsLastChildHeight;

		cpSticky = carPreviewVars.cPreview.hasClass('sticky');
	
		_self.stickyRimsFilters(rightContainerBottom, cpSticky);
		
		var fixedbutoonbar = $('#fixed-butoon-bar');
		var mobilecarpreview = $('#mobile-car-preview');
		
		fixedbutoonbar.removeClass('mobile-fixed-button');
		mobilecarpreview.removeClass('mobile-fixed');
		
		if (listingItemsVars.listingItemsHeight < 100) {
			listingItemsVars.listingItems.css({
				'margin-top': 345
			});
		}
		else {
			listingItemsVars.listingItems.css({
				'margin-top': 0
			});
		}
		
		if (($(window).scrollTop() > carPreviewVars.cpTop) && !isSmallScreen && (listingItemsVars.listingItemsHeight > 100)) {
			if (!cpSticky) {
				carPreviewVars.cPreview.addClass('sticky')
					.css({
						'width': carPreviewVars.cpWidth
					});
			}
			if (this.amountScrolled() >= this.calculateHeight()) {
				carPreviewVars.cPreview.removeClass('sticky');
				carPreviewVars.cpParent.addClass('container-fixed-block');
				carPreviewVars.cPreview.addClass('fixed-block');
				carPreviewVars.cPreview
					.css({
						'bottom': ''
					});
			} else {
				carPreviewVars.cpParent.removeClass('container-fixed-block');
				carPreviewVars.cPreview.removeClass('fixed-block');
				carPreviewVars.cPreview.css({
					'bottom': ''
				});
			}
		}
		else if (cpSticky) {
			carPreviewVars.cpParent.removeAttr("style");
			carPreviewVars.cPreview.removeClass('sticky');
			carPreviewVars.cPreview.removeClass('fixed-block')
				.css({
					'bottom': ''
				});
		}
	};
	
	this.winResized = function () {
		if ($(window).width() >= 991) {
			domRimFilters.show();
			isSmallScreen = false;
		} else {
			domRimFilters.hide();
			isSmallScreen = true;
		}
	};

	this.init = function () {
		window.onorientationchange = function () {
			_self.devRotated();
		};
		$(window).on("resize", function () {
			_self.winResized();
		});


		if ($("#complete_wheels_root_2021_main_wrapper").length>0) {
			_self.carPreviewInit();
		} else {
            if ($("#vehicle-preview").length>0) {
                $(window).on("scroll resize touchmove", function () {
                    _self.carPreviewInit();
                });
                _self.carPreviewInit();
            }
		}

		_self.bindUi();
		_self.devRotated();
		_self.winResized();

		_self.cwTabsButtons();
		_self.cwCarColors();
	};

    this.amountScrolled = function () {
        var winheight = $(window).height();
        var docheight = $(document).height();
        var scrollTop = $(window).scrollTop();
        var trackLength = docheight - winheight;
        var pctScrolled = Math.floor(scrollTop/trackLength * 100);
        return pctScrolled;
    }

    this.calculateHeight = function () {
		footerHeight = $(".footer-container").height();
		entirePageHeight= $( document ).height();
		pageWithoutFooterInPercentage = ((entirePageHeight-footerHeight)*100)/entirePageHeight;
		return pageWithoutFooterInPercentage;
	}
};
$(window).on("load", function() {
    jQuery(resp.init.bind(resp));
});

$('#carselector-default-submit-cw, #carselector-default-submit').click(function() {

	showLoadingSpinner();
	var submitButtonElement = this;
	setTimeout( function () {
	 	$(submitButtonElement).closest("form").submit();
	}, 10);
});
function showLoadingSpinner() {

	if( ! $('.loading-spinner-container').length ) {
		var $loadingSpinner = $(`
            <div class="loading-spinner-container">
                <div class="loading-spinner-overlay">
                    <div class="loading-spinner"></div>
                </div>
            </div>
        `);

		$("body").append($loadingSpinner);

		$loadingSpinner.click(function(e){
			e.stopPropagation();
		});
	}

	$('.loading-spinner-container').show();
}